import { Button, ButtonProps } from '@mantine/core';
import { BiLinkExternal } from 'react-icons/bi';
import { NETWORK_VARS } from 'src/constants';

interface TransactionLinkProps extends Omit<ButtonProps, 'onClick'> {
  hash: string;
  children?: React.ReactNode;
}

export function TransactionLink({
  hash,
  children = 'View Transaction',
  ...buttonProps
}: TransactionLinkProps) {
  return (
    <a
      href={`${NETWORK_VARS.explorer}/tx/${hash}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Button
        variant="subtle"
        size="xs"
        mt={8}
        leftSection={<BiLinkExternal size={16} />}
        {...buttonProps}
      >
        {children}
      </Button>
    </a>
  );
}
